<template>
	<div>
		<div style="color: #3e3e3e;font-size: 18px;margin-bottom: 15px;">权限设置>设置员工</div>
		<div class="wais">
			<div class="wai">
				<div class="title">
					<div class="blue"></div>
					<div style="flex: 1;">基本设置</div>
				</div>
				<!--  -->
				<el-form label-width="90px">
					<el-form-item label="账号">
						<div style="display: flex;" class="list1">
							<el-input v-model="form.memernames" size="small" placeholder="请输入员工手机号"
								style="margin-right: 10px;width:210px;"></el-input>
						</div>
					</el-form-item>
					<el-form-item label="登录密码">
						<div style="display: flex;" class="list1">
							<el-input v-model="form.memerpassword" size="small" type="password" placeholder="请输入密码"
								style="margin-right: 10px;width:210px;"></el-input>
							<el-button type="text">更改</el-button>
						</div>
						<span class="mioasu">6-15位数字、字母（区分大小写）</span>
					</el-form-item>
					<el-form-item label="确定密码">
						<div style="display: flex;" class="list1">
							<el-input v-model="form.truepassword" size="small" placeholder="请输入密码"
								style="margin-right: 10px;width:210px;"></el-input>
						</div>
					</el-form-item>
					<el-form-item label="姓名">
						<div style="display: flex;" class="list1">
							<el-input v-model="form.name" size="small" placeholder="请输入员工姓名"
								style="margin-right: 10px;width:210px;"></el-input>
						</div>
					</el-form-item>
					<el-form-item label="头像">
						<div style="display: flex;margin-left: 50px;">
							<upload id="upload" v-model="imgurl" style="width: 130px;height: 117px;"></upload>
							<div class="mberupload">
								<el-button type="primary" size="small" @click="uploadclick">选择文件</el-button>
								<p>图片格式为：bmp，jpeg，jpg，gif，尺寸1:1，不可大于1M</p>
							</div>
						</div>
					</el-form-item>
					<el-form-item label="描述">
						<div style="display: flex;margin-left: 50px;">
							<el-input type="textarea" maxlength="50" v-model="form.remk" placeholder="50字以内"
								@input="this.descInput"></el-input>
							<span
								style="float:right;color:#999;margin-left: 5px;margin-top: 5px;">{{this.remnant}}/50</span>
						</div>
					</el-form-item>
					<el-form-item label="账号状态">
						<div style="margin-left: 50px;">
							<div style="margin-top: 10px;">
								<el-radio v-model="radiostatus" label="1">启用</el-radio>
							</div>
							<div style="margin-top: 10px;">
								<el-radio v-model="radiostatus" label="2">停用</el-radio>
							</div>
						</div>
					</el-form-item>
					<el-form-item label="商品类目">
						<div style="margin-left: 50px;">
							<el-select v-model="value" placeholder="请选择" size="small">
								<el-option label="普通管理员" value="1"> </el-option>
								<el-option label="运营主管" value="2"> </el-option>
							</el-select>
						</div>
					</el-form-item>
				</el-form>
				<!--  -->
				<div class="button_s">
					<el-button size="small">取 消</el-button>
					<el-button type="primary" size="small">保 存</el-button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import upload from "../compents/upload/upload.vue"
	export default {
		components: {
			upload
		},
		data() {
			return {
				radiostatus: "",
				remnant: 50,
				form: {
					memernames: "", //会员名称
					memernamelength: "0", //会员名称长度
				},
				data: "123",
				value: "",
				checkes: [],
				serveradio: "",
				options: [],
				userhead: "",
				usercolor: "",
				userget: "",
				ljie: "", //外部连接
				checkedCities: [], //复选框
				radio1_data: "",
				radio1_time: "", //选项一绑定的时间
				cheosepeo: "",
				updatemethod: "", //更新方式
				radio: "",
				textAreaVal: "",
				labelname: "",
				ljnamelngth: 0,
				ljname: "",
				sharemoney: "", //分享获得奖励
				time1: "",
				time2: "",
				timeoptions: [{
					value: '选项1',
					label: '黄金糕'
				}, {
					value: '选项2',
					label: '双皮奶'
				}, {
					value: '选项3',
					label: '蚵仔煎'
				}, {
					value: '选项4',
					label: '龙须面'
				}, {
					value: '选项5',
					label: '北京烤鸭'
				}],
				imgurl: ""
			}
		},
		computed: {},
		watch: {
			form: {
				handler(val, oldVal) {
					this.form.memernamelength = val.memernames.length
					// this.textAreaVal = val
				},
				deep: true
			},
		},
		methods: {
			descInput() {
				var txtVal = this.form.remk.length;
				this.remnant = 50 - txtVal;
			},
			clearlists() {
				this.$confirm('是否删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			uploadclick() {
				document.querySelector(".el-upload--picture-card").click()
				document.getElementById("upload").click();
			}
		}
	};
</script>
<style lang="less" scoped>
	.wailianjie {
		display: flex;

		/deep/ .wailj_title {
			width: 100px;
		}
	}

	.dialog-footer {
		margin-right: 32%;
	}

	.button_s {
		margin-left: 200px;
	}

	.list1 {
		>div {
			padding-left: 50px;

			p {
				width: 233px;
				height: 47px;
				font-size: 14px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #C8C8C8;
				line-height: 2.1;
			}
		}
	}

	.mioasu {
		margin-left: 60px;
		font-size: 12px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3D3D3D;
		opacity: 0.38;
	}

	// 标题
	.waititle {
		width: 100%;
		font-weight: bold;
		display: flex;
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3e3e3e;

		.waititle1 {
			display: flex;
			flex: 1;
		}

		.waititle2 {
			display: flex;
		}

		.blue {
			width: 5px;
			position: relative;
			top: 3px;
			height: 15px;
			background: #409eff;
			border-radius: 2px;
			margin-right: 10px;
			margin-bottom: 20px;
		}
	}

	.title {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
		display: flex;
		font-weight: bold;
		margin-bottom: 10px;

		.blue {
			width: 5px;
			height: 15px;
			background: #409EFF;
			border-radius: 2px;
			margin-right: 8px;
			position: relative;
			top: 4px;
		}
	}

	.title2 {
		margin-top: 30px;
		margin-bottom: 30px;
	}

	.wais {
		display: flex;
	}

	.wai2 {
		.demo2 {
			margin-top: 50px;
			position: relative;
			left: 50%;
			margin-left: -175px;
			width: 300px;
			height: 600px;
			border-radius: 7px;
			overflow: hidden;
			margin: auto;

			img {
				width: 100%;
				height: 100%;
			}
		}

		// .demo2{
		// 	width: 308px;
		// 	height: 528px;
		// 	background: #ECECEC;
		// 	border-radius: 10px;
		// 	padding-top: 30px;
		// 	box-sizing: border-box;
		// 		img{
		// 			width: 407px;
		// 			height:854px;
		// 		}
		// 	p{
		// 		width: 100%;
		// 		text-align: center;
		// 		font-size: 16px;
		// 		font-family: Source Han Sans CN;
		// 		font-weight: 400;
		// 		color: #3E3E3E;
		// 	}
		// 	.img2{
		// 		width: 96px;
		// 		height: 97px;
		// 		border-radius: 7px;
		// 		overflow: hidden;
		// 		margin:auto;
		// 		margin-top: 200px;
		// 		img{
		// 			width: 100%;
		// 			height: 100%;
		// 		}
		// 	}
		// }
	}

	.adds {
		width: 145px;
		height: 34px;
		text-align: center;
		line-height: 34px;
		border: 1px dashed #9D9D9D;
		color: #9D9D9D;
		cursor: pointer;
	}

	.addlist {
		display: inline-block;
		margin-top: 10px;
		padding-left: 10px;
		padding-right: 10px;
		position: relative;
		text-align: center;
		border-radius: 5px;
		border: 1px solid black;
		transition: 0.3s;

		&:hover {
			div {
				display: block;
			}
		}

		div {
			display: none;
			cursor: pointer;
			position: absolute;
			top: -8px;
			right: -8px;
			background-color: red;
			color: white;
			border-radius: 50%;
			width: 20px;
			height: 20px;
			text-align: center;
			line-height: 20px;
			font-size: 16px;
		}
	}

	.mberupload {
		margin-left: 40px;

		p {
			width: 300px;
			font-size: 14px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #C8C8C8;
			line-height: 1.6;
		}
	}
</style>